import { cn } from '@/lib/utils'
import React from 'react'

interface DotBackgroundProps {
  children?: React.ReactNode
  className?: string
  showRadialGradient?: boolean
  dotSize?: number
}

export function DotBackground({
  children,
  className,
  showRadialGradient = true,
  dotSize = 20
}: DotBackgroundProps) {
  return (
    <div className={cn('bg-background relative w-full', className)}>
      <div
        className="absolute inset-0 opacity-70 dark:hidden"
        style={{
          backgroundSize: `${dotSize}px ${dotSize}px`,
          backgroundImage:
            'radial-gradient(circle, rgb(212, 212, 216) 1px, transparent 1px)'
        }}
      />
      <div
        className="absolute inset-0 hidden opacity-20 dark:block"
        style={{
          backgroundSize: `${dotSize}px ${dotSize}px`,
          backgroundImage:
            'radial-gradient(circle, rgb(113, 113, 122) 1px, transparent 1px)'
        }}
      />
      {/* Radial gradient for the container to give a faded look */}
      {showRadialGradient && (
        <div className="bg-background pointer-events-none absolute inset-0 flex items-center justify-center mask-[radial-gradient(ellipse_at_center,transparent_30%,var(--background))]"></div>
      )}
      {children && <div className="relative z-20">{children}</div>}
    </div>
  )
}
